import axios from 'axios'

const resetUri = '/api/password/reset'

export const validateUuid = (uuid: $TSFIXME): $TSFIXME => axios.get(resetUri + `?uuid=${uuid}`)
export const resetPassword = (uuid: $TSFIXME, email: string, password: string): $TSFIXME => axios.put(resetUri, { uuid, email, password })
